import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson1DefaultStartCode = `use option::OptionTrait;
${doNotModifyCodeAbove}`;

export const lesson1DefaultMiddleCode = `fn simple_option(optional_target: Option<felt252>) {
    // TODO: use the \`is_some\` and \`is_none\` methods to check if \`optional_target\` contains a value.
    // return the correct values to make the tests pass
}`;

export const lesson1DefaultEndCode = `${doNotModifyCodeBelow}
#[test]
fn test_options() {
    let target = 'starklings';
    let optional_some = Option::Some(target);
    let optional_none: Option<felt252> = Option::None(());
    assert('option has some' == simple_option(optional_some), 'err1');
    assert('option has none' == simple_option(optional_none), 'err2');
}`;
